export default "__VITE_ASSET__CgDbC0NX__"